import { z } from 'zod';
import { SourceSystem } from '../enums.js';
import { IsoDateTime, UuidString } from '../primitives.js';

/** Warehouse tree через parent_id + computed path[]. */
// S-FIX-4: BE list handler omits internal fields; made optional for prod parity.
export const Warehouse = z.object({
  id: UuidString,
  entity_id: UuidString.optional(),
  code: z.string().min(1),
  name: z.string().min(1),
  parent_id: UuidString.nullable().optional(),
  path: z.array(z.string()).default([]),
  is_group: z.boolean().default(false),
  is_active: z.boolean().default(true),
  address: z.string().nullable().optional(),
  source_system: SourceSystem.optional(),
  source_document_id: z.string().nullable().optional(),
  source_system_ref: z.record(z.unknown()).nullable().optional(),
  fetched_at: IsoDateTime.nullable().optional(),
  created_at: IsoDateTime.optional(),
  updated_at: IsoDateTime.optional(),
});
export type Warehouse = z.infer<typeof Warehouse>;
